import React, { useMemo } from 'react';
import FlipMove from "react-flip-move";
import { useOutletContext } from "react-router-dom";
import { usePositionForm } from "../../../providers/PositionFormProvider";
import NEWSkillFormButton from '../../profiles/components/NEWSkillFormButton';

const FilteredIndustries = ({ available = [], canRemove = true, ...props }) => {
    const { formModel: position } = usePositionForm();

    const [selectedIndustries, unselectedIndustries] = useMemo(() => {
        let [selected, unselected] = TB.partition(available, industry => !!TB.find(position.industries || [], ['id', industry.id]));

        selected = TB.orderBy(selected, industry => TB.map(position.industries || [], 'id').indexOf(industry.id));
        selected = TB.map(selected, industry => TB.find(position.industries || [], ['id', industry.id]))

        unselected = TB.map(unselected, industry => TB.pick(industry, ['id', 'name']))
        return [selected, unselected]
    }, [position.industries, available]);

    return (
        <div className="flex flex-col items-stretch relative">
            {selectedIndustries.length > 0 && (
                <div className="discipline-skills-container skill-importance-container relative gap-3">
                    <FlipMove typeName={null} maintainContainerHeight={true}>
                        {selectedIndustries.map(industry => (
                            <div key={industry.id}>
                                <NEWSkillFormButton
                                    valuePropName={'importance'}
                                    disabled={props.isDisabled}
                                    scoringOptions={laravel.importance_levels}
                                    skill={industry}
                                    disableRemove={!canRemove}
                                    onChange={selectIndustry}
                                    className="min-w-[115px]"
                                />
                            </div>
                        ))}
                    </FlipMove>
                </div>
            )}
            {props.children}
            {unselectedIndustries.length > 0 && (
                <div className="discipline-skills-container skill-importance-container relative">
                    <FlipMove typeName={null} maintainContainerHeight={true}>
                        {unselectedIndustries.map(industry => (
                            <div key={industry.id}>
                            <NEWSkillFormButton
                                valuePropName={'importance'}
                                disabled={props.isDisabled}
                                scoringOptions={laravel.importance_levels}
                                skill={industry}
                                onChange={(model) => props.onChange(model)}
                                className="min-w-[115px]"
                            />
                        </div>
                        ))}
                    </FlipMove>
                </div>
            )}
        </div>
    )
}
const PositionIndustries = props => {

    const { formModel: position, isProjectUpdating } = usePositionForm();
    const {
        isDisabled, goBack, onSubmit, onChange
    } = useOutletContext();

    const selectIndustry = async (industry) => {

        let industries = [...(position.industries || [])];


        if (TB.isDefined(industry.importance)) {
            if (TB.find(industries, ['id', parseInt(industry.id)])) {
                industries = TB.map(industries, model => {
                    if (model.id === parseInt(industry.id)) {
                        return { ...industry };
                    }
                    return model;
                });
            } else {
                industries.push(industry);
            }

        } else {
            industries = TB.xorBy(industries, [industry], 'id');
        }

        return onChange({ industries })
    }

    const allIndustries = useMemo(() => {
        let industries = TB.map(laravel.client_industries, (name, id) => ({ name, id: parseInt(id) }));

        let selectedIds = TB.map(position.industries || [], 'id')
        return TB.orderBy(industries, [
            industry => selectedIds.includes(industry.id) ? selectedIds.indexOf(industry.id) : 1000,
            industry => selectedIds.includes(industry.id),
        ], ['asc', 'asc'])
    }, [position.industries]);

    return (
        <div className="flex flex-col gap-[32px]">
            <div className="flex flex-col justify-start items-start self-stretch relative gap-4">
                <p className="self-stretch text-lg font-semibold text-left text-black">
                    Industry Experience Chosen
                </p>
                {/*{!position.industries?.length && (*/}
                {/*    <p className="self-stretch text-xs text-[#334d6e]">*/}
                {/*        No industries selected yet.*/}
                {/*    </p>*/}
                {/*)}*/}
                <p className="self-stretch text-xs text-[#334d6e]">
                    Choose Industries that Are Important for this Role
                </p>
                {position.industries?.length >= 10 && (
                    <div className="invalid-feedback flex text-muted">
                        Max limit reached for industry experience
                    </div>
                )}
            </div>
            <div className="discipline-skills-container skill-importance-container relative gap-3">
                <FlipMove typeName={null} maintainContainerHeight={true}>
                    {TB.map(allIndustries, (industry, index) => {
                        const match = TB.find(position.industries || [], ['id', industry.id])

                        return (
                            <div key={industry.id}>
                                <NEWSkillFormButton
                                    valuePropName={'importance'}
                                    disabled={isDisabled || isProjectUpdating}
                                    scoringOptions={laravel.importance_levels}
                                    skill={match || industry}
                                    onChange={selectIndustry}
                                    className="min-w-[115px]"
                                />
                            </div>
                        )
                    })}
                </FlipMove>
            </div>
        </div>
    );
};

PositionIndustries.propTypes = {

};

export default PositionIndustries;